import { render, staticRenderFns } from "./Plaid.vue?vue&type=template&id=6d23f38c&scoped=true"
import script from "./Plaid.vue?vue&type=script&lang=js"
export * from "./Plaid.vue?vue&type=script&lang=js"
import style0 from "./Plaid.vue?vue&type=style&index=0&id=6d23f38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23f38c",
  null
  
)

export default component.exports